import React from "react";
import { ShirtKit } from "./ShirtKit";

const GROUPS = [
  { cat: "GK", label: "Goalkeepers" },
  { cat: "DEF", label: "Defenders" },
  { cat: "MID", label: "Midfielders" },
  { cat: "FWD", label: "Forwards" },
];

// FPL "List View": players grouped by position in table rows.
export const FplListView = ({ xi, armbands, pendingPlayer, slotAccepts, onPlace, onCaptain }) => (
  <div data-testid="fpl-list-view" className="rounded-t-xl overflow-hidden bg-white text-[#0F172A]">
    {GROUPS.map((g) => {
      const rows = xi.filter((s) => s.cat === g.cat);
      if (!rows.length) return null;
      return (
        <div key={g.cat}>
          <div className="grid grid-cols-[1fr_64px_56px] px-3 py-2 text-[11px] font-bold uppercase tracking-wide text-white" style={{ background: "linear-gradient(90deg,#0F172A,#1E293B)" }}>
            <span>{g.label}</span>
            <span className="text-center">Club</span>
            <span className="text-right">Rating</span>
          </div>
          {rows.map((s) => {
            const p = s.player;
            const highlight = !p && pendingPlayer && slotAccepts(s, pendingPlayer);
            return (
              <div
                key={s.id}
                data-testid={`list-slot-${s.id}`}
                onClick={highlight ? () => onPlace(pendingPlayer, s.id) : p && onCaptain ? () => onCaptain(p.id || p.name) : undefined}
                className={`grid grid-cols-[1fr_64px_56px] items-center px-3 py-2 border-b border-[#0F172A]/10 text-sm ${
                  highlight ? "bg-[#10B981]/30 cursor-pointer animate-pulse" : "hover:bg-[#0F172A]/[0.03]"
                }`}
              >
                <span className="flex items-center gap-2 min-w-0">
                  <ShirtKit short={p?.short} color={p?.color} isGK={s.cat === "GK"} empty={!p} className="w-7 h-7 shrink-0 text-[#0F172A]/60" />
                  <span className="truncate font-semibold">{p ? p.name : `${s.label} — ${highlight ? "tap to place" : "empty"}`}</span>
                  {p && armbands[p.id || p.name] && (
                    <span className="shrink-0 w-4 h-4 rounded-full bg-[#1a1a1a] text-white text-[9px] font-extrabold flex items-center justify-center">
                      {armbands[p.id || p.name]}
                    </span>
                  )}
                </span>
                <span className="text-center text-xs font-semibold text-[#0F172A]/70">{p ? p.short : "–"}</span>
                <span className="text-right font-display font-extrabold">{p ? p.rating : "–"}</span>
              </div>
            );
          })}
        </div>
      );
    })}
  </div>
);

export default FplListView;
